import React, { ComponentProps, ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../layout/Box';
import { Image } from './Image';
import { MediaCover } from './MediaCover';
import defaultAvatar from './resources/defaultAvatar.svg';
import type { BreakpointProp } from '../../utils/styles/breakpoints';

export const AvatarCover = styled(MediaCover)`
    border-radius: 50%;
    overflow: hidden;
    user-select: none;
    background-color: var(--background-primary);
`;

interface AvatarProps extends ComponentProps<typeof Box> {
    title?: string;
    src?: string;
    size?: BreakpointProp<number>;
}

export const Avatar = forwardRef((props: AvatarProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { title = '', size = 32, src = defaultAvatar, ...other } = props;

    return (
        <AvatarCover ref={ref} width={size} ratio={1} {...other}>
            <Image src={src} alt={title} />
        </AvatarCover>
    );
});
